import { Link } from 'react-router-dom'
import { ArrowRight } from 'lucide-react'

export default function PageHero({ eyebrow, title, text, image, imageAlt, metric, metricLabel }) {
  return (
    <section className="page-hero section">
      <div className="container page-hero__grid">
        <div className="page-hero__copy reveal">
          <span className="eyebrow">{eyebrow}</span>
          <h1>{title}</h1>
          <p>{text}</p>
          <Link to="/contact" className="text-link">Discuss your learning goals <ArrowRight size={18} /></Link>
        </div>
        <div className="page-hero__visual reveal reveal--delay">
          <img src={image} alt={imageAlt} />
          {metric && <div className="metric-float"><strong>{metric}</strong><span>{metricLabel}</span></div>}
        </div>
      </div>
    </section>
  )
}
